module.exports = __webpack_public_path__ + "static/media/pilauto.e8f8410f.png";